import { Channel } from '@/types/workspace';
import { useQuery } from '@tanstack/react-query';

export function useChannel(channelId: string | null): {
    channel: Channel | null;
    isChannelLoading: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refetchChannel: () => Promise<any>;
} {
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['channel', channelId],
        queryFn: async () => {
            if (!channelId) return null;
            const response = await fetch(`/api/channels/${channelId}`);
            const data = await response.json();
            if (!response.ok)
                throw new Error(data.error || 'Channel not found');
            return data.channel as Channel;
        },
        enabled: !!channelId,
    });

    return {
        channel: data ?? null,
        isChannelLoading: isLoading,
        refetchChannel: refetch,
    };
}

export function useChannels(workspaceId: string | null): {
    channels: Channel[];
    isChannelsLoading: boolean;
} {
    const { data, isLoading } = useQuery({
        queryKey: ['channels', workspaceId],
        queryFn: async () => {
            if (!workspaceId) return [];
            const response = await fetch(
                `/api/channels?workspaceId=${workspaceId}`
            );
            const data = await response.json();
            console.log('-----CHANNELS', data);
            if (!response.ok)
                throw new Error(data.error || 'Failed to fetch channels');
            return data.channels ?? [];
        },
        enabled: !!workspaceId,
    });

    return {
        channels: data ?? [],
        isChannelsLoading: isLoading,
    };
}

export function usePartnerChannels(domain: string | null): {
    partnerChannels: Channel[];
    isPartnerChannelsLoading: boolean;
} {
    const { data, isLoading } = useQuery({
        queryKey: ['partnerChannels', domain],
        queryFn: async () => {
            if (!domain) return [];
            const response = await fetch(
                `/api/channels/partners?domain=${domain}`
            );
            const data = await response.json();
            if (!response.ok)
                throw new Error(
                    data.error || 'Failed to fetch partner channels'
                );
            return data.channels ?? [];
        },
        enabled: !!domain,
    });

    return {
        partnerChannels: data ?? [],
        isPartnerChannelsLoading: isLoading,
    };
}
